export default {"src":"https://fishbrain.com/_next/static/media/oklahoma.f0f1662c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};